var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.02,
    height: 49.988,
    viewBox: "0 0 50.02 49.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3aa0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bababa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.186,
    y1: 1.026,
    x2: 0.844,
    y2: 0.071,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcdcdc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611",
    transform: "translate(-609 -628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M55.42,19.9H40.32a2.078,2.078,0,0,0-2.08,2.08v10.7H24.69a2.078,2.078,0,0,0-2.08,2.08v12.4a2.078,2.078,0,0,0,2.08,2.08H44.32l9.81,7.8a2.1,2.1,0,0,0,3.39-1.64V21.98a2.109,2.109,0,0,0-2.1-2.08Z",
    transform: "translate(601.5 620.5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M40.31,7.5H9.58A2.078,2.078,0,0,0,7.5,9.58V43.02a2.093,2.093,0,0,0,3.39,1.64l9.81-7.8H40.33a2.078,2.078,0,0,0,2.08-2.08V9.58a2.1,2.1,0,0,0-2.1-2.08Z",
    transform: "translate(601.5 620.5)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(601.5 620.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M17.66,20.16H32.24a2.08,2.08,0,0,0,0-4.16H17.66a2.08,2.08,0,0,0,0,4.16Zm14.58,3.75H17.66a2.08,2.08,0,0,0,0,4.16H32.24a2.08,2.08,0,1,0,0-4.16Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.04a3a1956fadc996ea803d5ae174881b.svg";
export { ForwardRef as ReactComponent };